import { computed } from 'vue';
import { store } from '@/store/index';

/**
 * Chemican サイトの言語対応 URL を生成するコンポーザブル
 */
export const useChemicanUrls = () => {
  const chemicanUrl = process.env.VUE_APP_CHEMICAN_URL;

  // 現在のロケールを取得（ストアベース - 同期的）
  const currentLocale = computed(() => {
    return (
      store.getters['main/userLocale'] ||
      store.state.main.nonLoggedInUserLocale ||
      'ja-JP'
    );
  });

  // 厳密な言語判定
  const isEnglish = computed(() => {
    return (
      currentLocale.value === 'en-US' ||
      currentLocale.value === 'en' ||
      currentLocale.value.startsWith('en-')
    );
  });

  // 言語プレフィックスを取得
  const languagePrefix = computed(() => {
    return isEnglish.value ? 'en' : 'ja';
  });

  // 各種 URL を生成
  const signupUrl = computed(() => {
    return `${chemicanUrl}/${languagePrefix.value}/signup`;
  });

  const contactUrl = computed(() => {
    return `${chemicanUrl}/${languagePrefix.value}/contact`;
  });

  const documentUrl = computed(() => {
    return `${chemicanUrl}/${languagePrefix.value}/document`;
  });

  const pricingUrl = computed(() => {
    if (isEnglish.value) {
      return `${chemicanUrl}/en#s05`;
    } else {
      return `${chemicanUrl}/price`;
    }
  });

  const aboutUrl = computed(() => {
    if (isEnglish.value) {
      return 'https://chemican.com/en';
    } else {
      return 'https://chemican.com/';
    }
  });

  const featuresUrl = computed(() => {
    if (isEnglish.value) {
      return `${chemicanUrl}/en#s03`;
    } else {
      return `${chemicanUrl}/sds-manager`;
    }
  });

  const companyUrl = computed(() => {
    if (isEnglish.value) {
      return 'https://chemicancorp.com/';
    } else {
      return 'https://chemican.co.jp/';
    }
  });

  return {
    signupUrl,
    contactUrl,
    documentUrl,
    pricingUrl,
    aboutUrl,
    featuresUrl,
    companyUrl,
    currentLocale,
    languagePrefix,
  };
};
